/*
 *
 *  Deferred State
 *
 *  An alternative to event listening for state changes:
 *
 * 	var states = new DeferredState(['a','b']);
 * 	states.set('a');
 * 	states.a(function(){ console.log('It is a now.'); });
 * 	// console: Its is a now.
 * 	states.b(function(){ console.log('It is b now.'); });
 * 	states.set('b');
 * 	// console: It is b now.
 *
 */
import EventDispatcher from '../../lib/util/EventDispatcher.js';

function addFunction(instance, state) {
    instance[state] = function (callback, target) {
        var observer = this.addEventListener(state, callback, target);
        if (observer && state == this.state) {
            observer.call([this.state], this);
        }
        return this;
    };
}

function DeferredState(states) {
    this.___states = [];
    if (states) {
        for (var i = states.length - 1; i >= 0; i--) {
            this.___states.push(states[i]);
            addFunction(this, states[i]);
        }
    }
}
DeferredState.prototype = new EventDispatcher();
DeferredState.prototype.set = function (value) {
    if (value != this.state) {
        this.state = value;
        this.trigger(this.state);
    }
    return this;
};
DeferredState.prototype.unlisten = function (callback, target) {
    if (!(typeof callback == 'string' || typeof callback == 'function') && !target) {
        target = callback;
        this.removeEventListenersOf(target);
    } else {
        this.removeEventListener(null, callback, target);
    }
};

export default DeferredState;
